<template>
<pre>
  let gonzales = 500;
  document.getElementById("gonzales").innerHTML = gonzales;
</pre>
</template>